export const WF_VENDOR_UPDATE_FIELDS = [
    {
        label: "Vendor Information",
        sectionCode: "labels_vendor",
        fields: [
            {
                settingFieldName: 'vendorstype',
                formFieldname: 'vendorstype'
            },
            {
                settingFieldName: 'vendortype', //Vendor Email
                formFieldname: 'vendortype'
            },
            {
                settingFieldName: 'vendorphone',
                formFieldname: 'vendorphone'
            },
            {
                settingFieldName: 'timezone',
                formFieldname: 'timezone'
            },
            {
                settingFieldName: 'currency',
                formFieldname: 'currency'
            }
        ]
    },
    {
        label: "Business Details",
        sectionCode: "labels_businessdetails",
        fields: [
            {
                settingFieldName: 'dbaBussiness',
                formFieldname: 'dbaBussiness'
            },
            {
                settingFieldName: 'taxId',
                formFieldname: 'taxId'
            },
            {
                settingFieldName: 'ddemployees',
                formFieldname: 'ddemployees'
            },
            {
                settingFieldName: 'ddannualrevenue',
                formFieldname: 'ddannualrevenue'
            },
            {
                settingFieldName: 'dbownership',
                formFieldname: 'dbownership'
            },
            {
                settingFieldName: 'ddbusiness',
                formFieldname: 'ddbusiness'
            },
            {
                settingFieldName: 'ddfoundedyear',
                formFieldname: 'ddfoundedyear'
            },
            {
                settingFieldName: 'ddindustry',
                formFieldname: 'ddindustry'
            },
            {
                settingFieldName: 'txtsiccode',
                formFieldname: 'txtsiccode'
            },
            {
                settingFieldName: 'txtnaicscode',
                formFieldname: 'txtnaicscode'
            }
        ]
    },
    {
        label: "Payment Details",
        sectionCode: "labels_paymentdetails",
        fields: [
            {
                settingFieldName: 'ddPaymentMethod',
                formFieldname: 'ddPaymentMethod'
            },
            {
                settingFieldName: 'ddPaymentTerm',
                formFieldname: 'ddPaymentTerm'
            },
            {
                settingFieldName: 'txtShipMethod',
                formFieldname: 'txtShipMethod'
            }
        ]
    },
    {
        label: "Contact Information",
        sectionCode: "labels_contact",
        fields: [
            {
                settingFieldName: 'ddtitle',
                formFieldname: 'ddtitle'
            },
            {
                settingFieldName: 'txtfirst',
                formFieldname: 'txtfirst'
            },
            {
                settingFieldName: 'txtmiddle',
                formFieldname: 'txtmiddle'
            },
            {
                settingFieldName: 'txtlast',
                formFieldname: 'txtlast'
            },
            {
                settingFieldName: 'txtemail',
                formFieldname: 'txtemail'
            },
            {
                settingFieldName: 'txtphone',
                formFieldname: 'txtphone'
            },
            {
                settingFieldName: 'txtsocial',
                formFieldname: 'txtsocial'
            },
            {
                settingFieldName: 'ddgender',
                formFieldname: 'ddgender'
            },
            {
                settingFieldName: 'dob',
                formFieldname: 'dob'
            },
            {
                settingFieldName: 'ddlanguage',
                formFieldname: 'ddlanguage'
            },
            {
                settingFieldName: 'ddjobfunction',
                formFieldname: 'ddjobfunction'
            }
        ]
    },
    // {
    //     label: "Vendor Address",
    //     sectionCode: "labels_address",
    //     fields: [
    //         {
    //             settingFieldName: 'ddType',
    //             formFieldname: 'ddType'
    //         },
    //         {
    //             settingFieldName: 'txtMailStreet1',
    //             formFieldname: 'txtMailStreet1'
    //         },
    //         {
    //             settingFieldName: 'txtMailStreet2',
    //             formFieldname: 'txtMailStreet2'
    //         },
    //         {
    //             settingFieldName: 'txtMailzip',
    //             formFieldname: 'txtMailzip'
    //         }
    //     ]
    // },
    {
        label: 'Other 1',
        sectionCode: 'labels_vendor_other1',
        fields: []
    },
    {
        label: 'Other 2',
        sectionCode: 'labels_vendor_other2',
        fields: []
    },
    {
        label: 'Other 3',
        sectionCode: 'labels_vendor_other3',
        fields: []
    }
];
